var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Chip, Grid, IconButton, Radio, TextField, Typography, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { GridAddIcon, GridRemoveIcon } from "@mui/x-data-grid";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CheckAdditionalJobExistsUrl, CheckAlterNatePartsUrl, getCustomerDeclinedJobswithPriceUrl, DeclinedJobReasonListUrl, RevisedEstimateUpsertJobUrl, UpdateExistingJobQuantity, checkLabourAndPartPriceAdditionalJobUrl, getAdditionalJobsUrl, saveDeclinedPmPartsURl } from "../../../../api/url";
import { CrossCircleGray, CrossCircleRed, WarningTriangle } from "../../../../assets/images";
import { InputBox, MuiBorderBottom, MuiButton, MuiPopup, MuiStack } from "../../../../components";
import { MuiIconButton } from "../../../../components/atoms/iconButtonComponent";
import { MuiLoaderButton } from "../../../../components/atoms/loaderButton";
import { MuiSelectComponent } from "../../../../components/atoms/muiSelectComponent";
import { AlternatePartRelations, EModuleSection, EParentModuleName, ESystemName, E_Channel_Name, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from "../../../../constants";
import { setIsTaskDetailsDataUpdated, setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from "../../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI, setState } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { systemColor } from "../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { getSupersadeAlternatePartMessage, GoogleAnlyticsErrorLog } from "../../../../utils/utils";
import AlternatePartPopup from "./alternatePartPopup";
import SelectJobsComponent from "./selectJobComponent";
var BpIcon = styled('span')(function (_ref) {
    var theme = _ref.theme;
    return _objectSpread({
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2
        },
        'input:hover ~ &': _objectSpread({
            backgroundColor: '#ebf1f5'
        }, theme.applyStyles('dark', {
            backgroundColor: '#30404d'
        })),
        'input:disabled ~ &': _objectSpread({
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)'
        }, theme.applyStyles('dark', {
            background: 'rgba(57,75,89,.5)'
        }))
    }, theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
    }));
});
var BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""'
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3'
    }
});
// [
//     {
//         "AssociationName": AlternatePartRelations.OneWay,
//         "PartName": "UNDER BODY COATING",
//         "PartCode": "3M09",
//         "MinQuantity": 1,
//         "PartId": "db5b2dbf-e57c-4d94-a26e-f637023b618a",
//         "Price": 0,
//         isChecked: false
//     },
//     {
//         "AssociationName": AlternatePartRelations.OneWay,
//         "PartName": "UNDER BODY COATING",
//         "PartCode": "3M09",
//         "MinQuantity": 1,
//         "PartId": "db5b2dbf-e57c-4d94-a26e-f637023b618a",
//         "Price": 0,
//         isChecked: false
//     },
// ]
// Inspired by blueprintjs
function BpRadio(props) {
    return /*#__PURE__*/ React.createElement(Radio, _extends({
        disableRipple: true,
        color: "default",
        checkedIcon: /*#__PURE__*/ React.createElement(BpCheckedIcon, null),
        icon: /*#__PURE__*/ React.createElement(BpIcon, null)
    }, props));
}
export var RevisedEstimateAdditionalJobsComponent = function (props) {
    var parentModuleName = props.parentModuleName, callApIStatus = props.callApIStatus, isSaveButton = props.isSaveButton, additionalJobCallback = props.additionalJobCallback, isDisabled = props.isDisabled, isFromRevisedEstimate = props.isFromRevisedEstimate, sendDataToChild = props.sendDataToChild, getDataFromChild = props.getDataFromChild, SaveBtnStatus = props.SaveBtnStatus, onUpsertData = props.onUpsertData, alternatePartConfigState = props.alternatePartConfigState;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var techPackExcludePart = getLocalStorageItem(LOCAL_STORAGE_KEYS.Tech_Pack_Exclude_Part);
    var _a = useState(0), saveCount = _a[0], setSaveCount = _a[1];
    var _b = useState([]), declinedJobsList = _b[0], setDeclinedJobsList = _b[1];
    var _c = useState([]), manualJobsList = _c[0], setManualJobsList = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var _e = useState(null), duplicateItemDetails = _e[0], setDuplicateItemDetails = _e[1];
    var _f = useParams(), estimateId = _f.estimateId, _g = _f.inspectionId, inspectionId = _g === void 0 ? "estimate" : _g;
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var _h = useState(false), finishPopup = _h[0], setFinishPopup = _h[1];
    var _j = useState(false), disableSaveButton = _j[0], setDisableSaveButton = _j[1];
    var _k = useState(false), showDuplicateAlertPopup = _k[0], setShowDuplicateAlertPopup = _k[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _l = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _l.ModuleDetailsGetById, getModuleHeaderCount = _l.getModuleHeaderCount;
    var _m = useParams(), preJobCardDocumentId = _m.preJobCardDocumentId, id = _m.id;
    var dispatch = useAppDispatch();
    var _o = useState(0), quantity = _o[0], setQuantity = _o[1];
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var _p = useState(false), alternetPartPopupOpen = _p[0], setAlternetPartPopupOpen = _p[1];
    var _q = useState([]), alterNatePartDetails = _q[0], setAlterNatePartDetails = _q[1];
    var _r = useState(null), searchedPart = _r[0], setSearchedPart = _r[1];
    var replacePart = function () {
        var index = manualJobsList.findIndex(function (item) { return item.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId); });
        if (index >= 0) {
            var alternatePart = alterNatePartDetails === null || alterNatePartDetails === void 0 ? void 0 : alterNatePartDetails.find(function (item) { return item.isChecked; });
            var jobs = __spreadArray([], manualJobsList, true);
            jobs[index] = alternatePart ? _objectSpread(_objectSpread(_objectSpread({}, jobs[index]), {}, {
                Name: alternatePart.PartName
            }, alternatePart), {}, {
                ChildId: alternatePart.PartId
            }) : _objectSpread({}, jobs[index]);
            setManualJobsList(jobs);
        }
        setAlternetPartPopupOpen(false);
    };
    useEffect(function () {
        if (callApIStatus || isFromRevisedEstimate) {
            initiate();
        }
        if (declinedJobsList.length === 0 && manualJobsList.length === 0) {
            setDisableSaveButton(true);
            if (SaveBtnStatus) {
                SaveBtnStatus(true);
            }
            // if (getDataFromChild) {
            //     getDataFromChild(true);
            // }
        }
    }, [callApIStatus, isFromRevisedEstimate]);
    useEffect(function () {
        var fetchDeclinedJobReasons = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _response$payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: DeclinedJobReasonListUrl
                        }))];
                    case 1:
                        response = _a.sent();
                        if (response && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.data && response.payload.success) {
                            setRejectReasonRemarkList(response.payload.data);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchDeclinedJobReasons();
    }, []);
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, getAdditionalJobList()];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getAdditionalJobList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _ModuleDetailsGetById2, _savedAdditionalJobsR, _savedAdditionalJobsR2, _ModuleDetailsGetById3, _ModuleDetailsGetById4, _ModuleDetailsGetById5, _declinedResponse$pay, _declinedResponse$pay2, estimateRequest, savedAdditionalJobsResponse, savedJobs, _savedAdditionalJobsR3, _savedAdditionalJobsR4, request, declinedResponse, declinedJobs, _declinedResponse$pay3, _declinedResponse$pay4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    estimateRequest = {
                        EstimateId: preJobCardDocumentId,
                        OrganizationId: (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.OrganizationId) || "",
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.VinNo
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getAdditionalJobsUrl,
                            request: estimateRequest
                        }))];
                case 1:
                    savedAdditionalJobsResponse = _a.sent();
                    savedJobs = [];
                    if (savedAdditionalJobsResponse !== null && savedAdditionalJobsResponse !== void 0 && (_savedAdditionalJobsR = savedAdditionalJobsResponse.payload) !== null && _savedAdditionalJobsR !== void 0 && _savedAdditionalJobsR.success && savedAdditionalJobsResponse !== null && savedAdditionalJobsResponse !== void 0 && (_savedAdditionalJobsR2 = savedAdditionalJobsResponse.payload) !== null && _savedAdditionalJobsR2 !== void 0 && (_savedAdditionalJobsR2 = _savedAdditionalJobsR2.data) !== null && _savedAdditionalJobsR2 !== void 0 && _savedAdditionalJobsR2.AdditionalJobs) {
                        savedAdditionalJobsResponse === null || savedAdditionalJobsResponse === void 0 || (_savedAdditionalJobsR3 = savedAdditionalJobsResponse.payload) === null || _savedAdditionalJobsR3 === void 0 || (_savedAdditionalJobsR3 = _savedAdditionalJobsR3.data) === null || _savedAdditionalJobsR3 === void 0 || (_savedAdditionalJobsR3 = _savedAdditionalJobsR3.AdditionalJobs) === null || _savedAdditionalJobsR3 === void 0 || _savedAdditionalJobsR3.Labour.forEach(function (item) {
                            savedJobs.push(_objectSpread(_objectSpread({}, item), {}, {
                                jobType: "Labour",
                                Name: item.LabourName,
                                isDeclined: false,
                                isAlreadySaved: true,
                                DecimalPrecision: item.DecimalPrecision || 0
                            }));
                        });
                        savedAdditionalJobsResponse === null || savedAdditionalJobsResponse === void 0 || (_savedAdditionalJobsR4 = savedAdditionalJobsResponse.payload) === null || _savedAdditionalJobsR4 === void 0 || (_savedAdditionalJobsR4 = _savedAdditionalJobsR4.data) === null || _savedAdditionalJobsR4 === void 0 || (_savedAdditionalJobsR4 = _savedAdditionalJobsR4.AdditionalJobs) === null || _savedAdditionalJobsR4 === void 0 || _savedAdditionalJobsR4.Part.forEach(function (item) {
                            savedJobs.push(_objectSpread(_objectSpread({}, item), {}, {
                                jobType: "Part",
                                Name: item.PartName,
                                isDeclined: false,
                                isAlreadySaved: true,
                                DecimalPrecision: item.DecimalPrecision || 0
                            }));
                        });
                    }
                    request = {
                        ParentId: preJobCardDocumentId,
                        InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.InstallBaseId,
                        ServiceDetailType: 1,
                        OrganizationId: (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.OrganizationId) || "",
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.VinNo
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getCustomerDeclinedJobswithPriceUrl,
                            request: request
                        }))];
                case 2:
                    declinedResponse = _a.sent();
                    declinedJobs = [];
                    if (declinedResponse && (_declinedResponse$pay = declinedResponse.payload) !== null && _declinedResponse$pay !== void 0 && (_declinedResponse$pay = _declinedResponse$pay.value) !== null && _declinedResponse$pay !== void 0 && _declinedResponse$pay.data && (_declinedResponse$pay2 = declinedResponse.payload) !== null && _declinedResponse$pay2 !== void 0 && (_declinedResponse$pay2 = _declinedResponse$pay2.value) !== null && _declinedResponse$pay2 !== void 0 && _declinedResponse$pay2.success) {
                        declinedResponse === null || declinedResponse === void 0 || (_declinedResponse$pay3 = declinedResponse.payload) === null || _declinedResponse$pay3 === void 0 || (_declinedResponse$pay3 = _declinedResponse$pay3.value) === null || _declinedResponse$pay3 === void 0 || (_declinedResponse$pay3 = _declinedResponse$pay3.data) === null || _declinedResponse$pay3 === void 0 || _declinedResponse$pay3.Labour.forEach(function (item) {
                            declinedJobs.push(_objectSpread(_objectSpread({}, item), {}, {
                                jobType: "Labour",
                                Name: item.LabourName,
                                isDeclined: true,
                                DecimalPrecision: item.DecimalPrecision || 0
                            }));
                        });
                        declinedResponse === null || declinedResponse === void 0 || (_declinedResponse$pay4 = declinedResponse.payload) === null || _declinedResponse$pay4 === void 0 || (_declinedResponse$pay4 = _declinedResponse$pay4.value) === null || _declinedResponse$pay4 === void 0 || (_declinedResponse$pay4 = _declinedResponse$pay4.data) === null || _declinedResponse$pay4 === void 0 || _declinedResponse$pay4.Part.forEach(function (item) {
                            declinedJobs.push(_objectSpread(_objectSpread({}, item), {}, {
                                jobType: "Part",
                                Name: item.PartName,
                                isDeclined: true,
                                DecimalPrecision: item.DecimalPrecision || 0
                            }));
                        });
                    }
                    setDeclinedJobsList(__spreadArray(__spreadArray([], declinedJobs, true), savedJobs, true));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSelectJobItem = function (option, selectedOption) { return __awaiter(void 0, void 0, void 0, function () {
        var techPackExcludePartArray, profileData, _ModuleDetailsGetById6, _ModuleDetailsGetById7, _ModuleDetailsGetById8, _ModuleDetailsGetById9, _ModuleDetailsGetById10, object, ResponseData, jobFilter, _ResponseData$payload, _ModuleDetailsGetById11, _ModuleDetailsGetById12, _ModuleDetailsGetById13, _ModuleDetailsGetById14, _ResponseData$payload2, _ResponseData$payload3, _Response$payload, object1, alterNatePartPayload, updatedOption_1, result, _result$payload$data, alternateParts, alternatePartItem, Response, _Response$payload2, data, duplicatePartDetails, duplicateLabourDetails, itemDetails, _ResponseData$payload4, _ResponseData$payload5, updatedOption_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV) {
                        techPackExcludePartArray = techPackExcludePart !== null && techPackExcludePart !== void 0 && techPackExcludePart.Value ? techPackExcludePart.Value.split(',').map(function (code) { return code.trim(); }) : [];
                        if (option !== null && option !== void 0 && option.SkuCode && techPackExcludePartArray.includes(option.SkuCode)) {
                            dispatch(showLoader({
                                isLoaderOpen: false
                            }));
                            dispatch(showNotification({
                                isOpen: true,
                                message: "".concat(option === null || option === void 0 ? void 0 : option.Name, "(#").concat(option === null || option === void 0 ? void 0 : option.SkuCode, ") is part of a Tech Pack. Please select this part from CDMS Job Card."),
                                type: "error"
                            }));
                            return [2 /*return*/];
                        }
                    }
                    if (!(option.Key == "Discontinued")) return [3 /*break*/, 1];
                    profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("The item you are going to transact is mark as Discontinued"));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("The item you are going to transact is mark as Discontinued"),
                        type: "error"
                    }));
                    return [3 /*break*/, 7];
                case 1:
                    object = {
                        SystemName: selectedOption === "Part" ? "Product" : 'Labour',
                        ChildId: option.id,
                        Quantity: option.Quantity ? Number(option.Quantity) : 1,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById7 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById7 === void 0 ? void 0 : _ModuleDetailsGetById7.VinNo,
                        ProductId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById8 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById8 === void 0 ? void 0 : _ModuleDetailsGetById8.ProductId,
                        PreJobCardDocumentId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById9 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById9 === void 0 ? void 0 : _ModuleDetailsGetById9.PreJobCardDocumentId,
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById10 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById10 === void 0 ? void 0 : _ModuleDetailsGetById10.RepairTypeId
                    };
                    if (parentModuleName === EParentModuleName.RevisedServiceEstimate) {
                        object.JobCardId = id;
                    }
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: checkLabourAndPartPriceAdditionalJobUrl,
                            request: object
                        }))];
                case 2:
                    ResponseData = _a.sent();
                    jobFilter = __spreadArray(__spreadArray([], declinedJobsList, true), manualJobsList, true).filter(function (o) { return (o === null || o === void 0 ? void 0 : o.ChildId) == option.id || (o === null || o === void 0 ? void 0 : o.id) == option.id; });
                    if (!option) return [3 /*break*/, 7];
                    if (!((jobFilter === null || jobFilter === void 0 ? void 0 : jobFilter.length) == 0 && (ResponseData === null || ResponseData === void 0 || (_ResponseData$payload = ResponseData.payload) === null || _ResponseData$payload === void 0 ? void 0 : _ResponseData$payload.statusCode) == 200)) return [3 /*break*/, 7];
                    if (!(props.parentModuleName === EParentModuleName.RevisedServiceEstimate)) return [3 /*break*/, 6];
                    object1 = {
                        JobCardId: id,
                        ChildId: option.id,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById11 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById11 === void 0 ? void 0 : _ModuleDetailsGetById11.VinNo,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById12 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById12 === void 0 ? void 0 : _ModuleDetailsGetById12.OrganizationId
                    };
                    alterNatePartPayload = {
                        "PartId": option.id,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById13 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById13 === void 0 ? void 0 : _ModuleDetailsGetById13.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById14 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById14 === void 0 ? void 0 : _ModuleDetailsGetById14.VinNo
                    };
                    updatedOption_1 = _objectSpread(_objectSpread({}, option), {}, {
                        jobType: selectedOption,
                        IsAllowForEdit: ResponseData === null || ResponseData === void 0 || (_ResponseData$payload2 = ResponseData.payload) === null || _ResponseData$payload2 === void 0 ? void 0 : _ResponseData$payload2.IsAllowForEdit,
                        Price: ResponseData === null || ResponseData === void 0 || (_ResponseData$payload3 = ResponseData.payload) === null || _ResponseData$payload3 === void 0 ? void 0 : _ResponseData$payload3.Price
                    });
                    result = null;
                    if (!alternatePartConfigState["Additional Jobs"]) return [3 /*break*/, 4];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAlterNatePartsUrl,
                            request: alterNatePartPayload
                        }))];
                case 3:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    _a.label = 4;
                case 4:
                    if (result && result.payload && result.payload.success) {
                        alternateParts = (_result$payload$data = result.payload.data) !== null && _result$payload$data !== void 0 ? _result$payload$data : [];
                        alternatePartItem = alternateParts.find(function (item) { return item.AssociationName === AlternatePartRelations.Superseds; });
                        if (alternatePartItem) {
                            updatedOption_1 = _objectSpread(_objectSpread({}, updatedOption_1), {}, {
                                Name: alternatePartItem.PartName,
                                ChildId: alternatePartItem.PartId
                            });
                            dispatch(showNotification({
                                isOpen: true,
                                message: getSupersadeAlternatePartMessage(alternatePartItem.PartName, updatedOption_1.Name),
                                type: "success"
                            }));
                        }
                        else {
                            setAlterNatePartDetails(alternateParts);
                            setAlternetPartPopupOpen(alternateParts.length > 0);
                            setSearchedPart(_objectSpread(_objectSpread({}, updatedOption_1), {}, {
                                isChecked: true
                            }));
                        }
                    }
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAdditionalJobExistsUrl,
                            request: object1
                        }))];
                case 5:
                    Response = _a.sent();
                    if ((Response === null || Response === void 0 || (_Response$payload = Response.payload) === null || _Response$payload === void 0 ? void 0 : _Response$payload.statusCode) == 200) {
                        setManualJobsList(function (prev) { return __spreadArray(__spreadArray([], prev, true), [updatedOption_1], false); });
                        setSaveCount(saveCount + 1);
                        dispatch(setIsTaskDetailsDataUpdated(true));
                        setDisableSaveButton(false);
                        if (SaveBtnStatus) {
                            SaveBtnStatus(false);
                        }
                        if (manualJobsList.length > 0 && additionalJobCallback) {
                            additionalJobCallback(true);
                        }
                        data = Response === null || Response === void 0 || (_Response$payload2 = Response.payload) === null || _Response$payload2 === void 0 ? void 0 : _Response$payload2.data;
                        duplicatePartDetails = data && data.Part && data.Part[0] ? data.Part[0] : null;
                        duplicateLabourDetails = data && data.Labour && data.Labour[0] ? data.Labour[0] : null;
                        itemDetails = null;
                        if (duplicatePartDetails) {
                            itemDetails = _objectSpread(_objectSpread({}, duplicatePartDetails), {}, {
                                ItemName: duplicatePartDetails.PartName,
                                isPart: true
                            });
                        }
                        else if (duplicateLabourDetails) {
                            itemDetails = _objectSpread(_objectSpread({}, duplicateLabourDetails), {}, {
                                ItemName: duplicateLabourDetails.LabourName,
                                isPart: false
                            });
                        }
                        setDuplicateItemDetails(itemDetails);
                        setShowDuplicateAlertPopup(!!itemDetails);
                    }
                    return [3 /*break*/, 7];
                case 6:
                    updatedOption_2 = _objectSpread(_objectSpread({}, option), {}, {
                        jobType: selectedOption,
                        IsAllowForEdit: ResponseData === null || ResponseData === void 0 || (_ResponseData$payload4 = ResponseData.payload) === null || _ResponseData$payload4 === void 0 ? void 0 : _ResponseData$payload4.IsAllowForEdit,
                        Price: ResponseData === null || ResponseData === void 0 || (_ResponseData$payload5 = ResponseData.payload) === null || _ResponseData$payload5 === void 0 ? void 0 : _ResponseData$payload5.Price
                    });
                    setManualJobsList(function (prev) { return __spreadArray(__spreadArray([], prev, true), [updatedOption_2], false); });
                    setSaveCount(saveCount + 1);
                    dispatch(setIsTaskDetailsDataUpdated(true));
                    setDisableSaveButton(false);
                    if (manualJobsList.length > 0 && additionalJobCallback) {
                        additionalJobCallback(true);
                    }
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleSaveClick = function () {
        AddedJobsItem();
        if (additionalJobCallback) {
            additionalJobCallback(false);
        }
    };
    var AddedJobsItem = function () { return __awaiter(void 0, void 0, void 0, function () {
        var additionalJobs, declinedAdditionalJobsList, jobsList, _ModuleDetailsGetById18, Request, ResponseData, _ModuleDetailsGetById19, _ResponseData$payload6, saveDeclinedJobsPayload, saveDeclinedPmPartsResponse, sortedList_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    additionalJobs = [];
                    declinedAdditionalJobsList = [];
                    jobsList = __spreadArray(__spreadArray([], declinedJobsList, true), manualJobsList, true);
                    if (!(jobsList.length >= 0)) return [3 /*break*/, 4];
                    jobsList.map(function (item) {
                        if (!item.isDeclined) {
                            var _ModuleDetailsGetById15, _ModuleDetailsGetById16;
                            var object = {
                                SystemName: item.jobType === "Part" ? "Product" : 'Labour',
                                ChildId: item.id || item.ChildId,
                                Quantity: item.Quantity ? Number(item.Quantity) : 1,
                                OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById15 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById15 === void 0 ? void 0 : _ModuleDetailsGetById15.OrganizationId,
                                VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById16 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById16 === void 0 ? void 0 : _ModuleDetailsGetById16.VinNo,
                                IsAllowForEdit: item.IsAllowForEdit,
                                Price: item.Price,
                                ChildName: item.Name,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.SkuCode) || (item === null || item === void 0 ? void 0 : item.PartCode) || (item === null || item === void 0 ? void 0 : item.LabourCode) || (item === null || item === void 0 ? void 0 : item.Code) || ""
                            };
                            additionalJobs.push(object);
                        }
                        else {
                            var _ModuleDetailsGetById17;
                            declinedAdditionalJobsList.push({
                                SystemName: (item === null || item === void 0 ? void 0 : item.jobType) === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                DeclineDateTime: new Date(),
                                Remarks: item.DeclinedRemarks ? item.DeclinedRemarks : "",
                                ServiceTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById17 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById17 === void 0 ? void 0 : _ModuleDetailsGetById17.RepairTypeId,
                                DeclinedJobReasonId: item.RejectReasonRemark ? item.RejectReasonRemark : null,
                                ServiceDetailType: 1,
                                ParentSystemName: ESystemName.Estimate,
                                Price: item.Price ? Number(item === null || item === void 0 ? void 0 : item.Price) / Number(item.Quantity) : 0,
                                Quantity: item.Quantity
                            });
                        }
                    });
                    Request = {
                        RevisedEstimateId: id,
                        AdditionalJobs: additionalJobs,
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById18 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById18 === void 0 ? void 0 : _ModuleDetailsGetById18.RepairTypeId
                    };
                    if (props.parentModuleName === EParentModuleName.Inspection) {
                        Request.InspectionId = inspectionId;
                    }
                    else if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                        Request.EstimateId = estimateId;
                    }
                    else if (props.parentModuleName === EParentModuleName.RevisedServiceEstimate) {
                        Request.RevisedEstimateId = (sendDataToChild === null || sendDataToChild === void 0 ? void 0 : sendDataToChild.RevisedEstimateId) || preJobCardDocumentId;
                    }
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: RevisedEstimateUpsertJobUrl,
                            request: Request
                        }))];
                case 1:
                    ResponseData = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!ResponseData.payload.success) return [3 /*break*/, 3];
                    saveDeclinedJobsPayload = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById19 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById19 === void 0 ? void 0 : _ModuleDetailsGetById19.InstallBaseId,
                        "DeclinedJobs": declinedAdditionalJobsList,
                        "ParentId": (sendDataToChild === null || sendDataToChild === void 0 ? void 0 : sendDataToChild.RevisedEstimateId) || preJobCardDocumentId,
                        ServiceDetailType: 1
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedJobsPayload
                        }))];
                case 2:
                    saveDeclinedPmPartsResponse = _a.sent();
                    if (getDataFromChild) {
                        getDataFromChild(false);
                    }
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Additional jobs saved successfully",
                        type: "success"
                    }));
                    sortedList_1 = [];
                    updatedModuleSectionByChannel.map(function (item) {
                        var data = deepClone(item);
                        if (item.Key == EModuleSection.AdditionalJobs) {
                            if (Module === isModuleConfig.Product) {
                                data.SectionAttributes[0].MANDATORY = jobsList.length > 0 ? true : false;
                                data.SectionAttributes[0].MANDATORYDefaultValue = jobsList.length > 0 ? true : false;
                            }
                        }
                        sortedList_1.push(data);
                    });
                    dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                    dispatch(setTaskDetailsDataSaved(true));
                    if ((ResponseData === null || ResponseData === void 0 || (_ResponseData$payload6 = ResponseData.payload) === null || _ResponseData$payload6 === void 0 || (_ResponseData$payload6 = _ResponseData$payload6.data) === null || _ResponseData$payload6 === void 0 ? void 0 : _ResponseData$payload6.length) > 0) {
                        dispatch(setSavedTaskDetailsCount({
                            additionalJobsCount: saveCount
                        }));
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                AdditionalParts: jobsList.length
                            })
                        }));
                    }
                    else {
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                                AdditionalParts: jobsList.length
                            })
                        }));
                    }
                    if (SaveBtnStatus) {
                        SaveBtnStatus(true);
                    }
                    if (onUpsertData) {
                        onUpsertData();
                    }
                    setFinishPopup(true);
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    setFinishPopup(true);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveJobItem = function (item, index, isDeclinedJob) {
        if (!isDeclinedJob) {
            var updatedManualJobs = manualJobsList.filter(function (i) { return i.id !== (item === null || item === void 0 ? void 0 : item.id); });
            setManualJobsList(updatedManualJobs);
        }
        var list = __spreadArray([], declinedJobsList, true);
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var element = list_1[_i];
            if (element.ChildId === item.ChildId) {
                element.isDeclined = !element.isDeclined;
            }
        }
        setDeclinedJobsList(list);
    };
    var handleRejectReasonChange = function (event, index) {
        var updatedList = __spreadArray([], declinedJobsList, true);
        updatedList[index].rejectReason = event.target.value;
        setDeclinedJobsList(updatedList);
        dispatch(setIsTaskDetailsDataUpdated(true));
    };
    var allJobsList = __spreadArray(__spreadArray([], declinedJobsList, true), manualJobsList, true);
    var updateQuantity = function () {
        var body = {
            JobCardId: id,
            ChildId: duplicateItemDetails && duplicateItemDetails.ChildId ? duplicateItemDetails.ChildId : "",
            Quantity: duplicateItemDetails && duplicateItemDetails.Quantity ? duplicateItemDetails.Quantity : ""
        };
        dispatch(showLoader({
            isLoaderOpen: true
        }));
        dispatch(createAPI({
            key: "",
            url: UpdateExistingJobQuantity,
            request: body
        })).finally(function () {
            dispatch(showLoader({
                isLoaderOpen: false
            }));
            setShowDuplicateAlertPopup(false);
        });
    };
    var handleIncrement = function () {
        if (duplicateItemDetails) {
            setDuplicateItemDetails(_objectSpread(_objectSpread({}, duplicateItemDetails), {}, {
                Quantity: duplicateItemDetails.Quantity + 1
            }));
        }
    };
    var handleDecrement = function () {
        if (duplicateItemDetails && duplicateItemDetails.Quantity > 1) {
            setDuplicateItemDetails(_objectSpread(_objectSpread({}, duplicateItemDetails), {}, {
                Quantity: duplicateItemDetails.Quantity - 1
            }));
        }
    };
    var getAvailablePartSection = function () {
        var section = "";
        switch (duplicateItemDetails === null || duplicateItemDetails === void 0 ? void 0 : duplicateItemDetails.JobCardServiceGroup) {
            case 1:
                section = "Additional jobs";
                break;
            case 2:
                section = "Standard jobs";
                break;
            case 3:
                section = "PM parts";
                break;
            default:
                break;
        }
        return section;
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Add job")), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingTop: 1,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(SelectJobsComponent, {
        isDisabled: isDisabled,
        onSelectOption: handleSelectJobItem
    })), allJobsList.length !== 0 && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("ADDED_JOBS")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        paddingTop: 0.5,
        rowGap: 2
    }, allJobsList.map(function (item, index) {
        var _item$jobType, _item$Remarks;
        var isDeclinedJob = item.isDeclined;
        return /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 0.5,
            key: index,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 9,
            sm: 10,
            md: 9.5,
            lg: 10
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1.25,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            lineHeight: 2
        }, item.Name), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                backgroundColor: "#EEF6FF",
                padding: "3px 8px",
                borderRadius: "50%",
                border: "1px solid #AFD5FF",
                justifyContent: "center"
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: systemColor.primary
            },
            variant: "h5"
        }, (_item$jobType = item.jobType) === null || _item$jobType === void 0 ? void 0 : _item$jobType.substring(0, 1))))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 2,
            sm: 1,
            md: 1.5,
            lg: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "job-price",
            style: {
                opacity: isDisabled ? 0.7 : 1
            }
        }, item.Price ? "\u20B9 ".concat(item.Price.toFixed(2)) : '')), !item.isAlreadySaved && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 1,
            sm: 1,
            md: 1,
            lg: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "row",
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "remove-job-btn",
            onClick: function () { return handleRemoveJobItem(item, index, isDeclinedJob); },
            disabled: isDisabled,
            style: {
                opacity: isDisabled ? 0.7 : 1
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: item.isDeclined ? CrossCircleRed : CrossCircleGray,
            alt: "toggle-decline"
        })))), isDeclinedJob && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            lg: 12,
            md: 12,
            sm: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2,
            direction: "column"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: "white",
            borderRadius: "8px"
        }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            id: "reject-reason-dropdown",
            margin: 0,
            fullWidth: true,
            options: rejectReasonRemarkList,
            caption: "Reason for Rejection",
            displayExpr: "DisplayName",
            valueExpr: "id",
            name: "rejectReason",
            value: item.DeclinedJobReasonId || "",
            onChange: function (event) { return handleRejectReasonChange(event, index); },
            disabled: true
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: "white",
            borderRadius: "8px"
        }, /*#__PURE__*/ React.createElement(InputBox, {
            id: "remark-input",
            placeholder: t("ENTER_REMARKS_PLACEHOLDER"),
            fullWidth: true,
            size: "small",
            value: (_item$Remarks = item.Remarks) !== null && _item$Remarks !== void 0 ? _item$Remarks : "",
            disabled: true
        })))));
    }), isSaveButton && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiBorderBottom, null), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        size: "medium",
        loading: loader.isLoaderOpen,
        name: t("Save"),
        id: "additionalJobSave",
        variant: "contained",
        onClick: handleSaveClick
    })))), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: showDuplicateAlertPopup && duplicateItemDetails
        // openPopup={true}
        ,
        onClose: function () {
            setShowDuplicateAlertPopup(false);
        },
        backdropEnable: true,
        containerStyle: {
            width: IS_MOBILE ? "100%" : '450px',
            height: "575px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement("img", {
        src: WarningTriangle
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold"
    }, "Already available in JC"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "textSecondary"
    }, "This part is already added in ", getAvailablePartSection())), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        bgcolor: '#F4F7FA',
        padding: 1,
        border: 1,
        borderRadius: 2,
        borderColor: "grey.300"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, duplicateItemDetails && duplicateItemDetails.ItemName ? duplicateItemDetails.ItemName : "-"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "textSecondary"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        container: true,
        justifyContent: "flex-start"
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: duplicateItemDetails && duplicateItemDetails.isPart ? 'P' : 'L',
        size: "small",
        sx: {
            ml: 1,
            color: systemColor.primary,
            border: '1px solid #AFD5FF',
            bgcolor: "#EEF6FF"
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, "\u20B9 ", duplicateItemDetails && typeof Number(duplicateItemDetails.Price) === 'number' ? duplicateItemDetails.Price.toFixed(2) : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 8
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: "#A8B5C2"
    }, "Service type :"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1"
    }, duplicateItemDetails && duplicateItemDetails.ServiceTypeId ? duplicateItemDetails.ServiceTypeId : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "textSecondary"
    }, "Qty:"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, duplicateItemDetails && typeof Number(duplicateItemDetails.Quantity) === 'number' ? duplicateItemDetails.Quantity : "-")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold"
    }, "Additional jobs")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        padding: 1,
        border: 1,
        borderRadius: 2,
        borderColor: "grey.300"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, duplicateItemDetails && duplicateItemDetails.ItemName ? duplicateItemDetails.ItemName : "-"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "textSecondary"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        container: true,
        justifyContent: "flex-start"
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: duplicateItemDetails && duplicateItemDetails.isPart ? 'P' : 'L',
        size: "small",
        sx: {
            ml: 1,
            color: systemColor.primary,
            border: '1px solid #AFD5FF',
            bgcolor: "#EEF6FF"
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        container: true,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, "\u20B9 ", duplicateItemDetails && duplicateItemDetails.Price ? duplicateItemDetails.Price.toFixed(2) : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: "#A8B5C2"
    }, "Service type :"), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "reject-reason-dropdown",
        margin: 0,
        value: duplicateItemDetails && duplicateItemDetails.JobCardServiceGroup ? duplicateItemDetails.JobCardServiceGroup : "-",
        fullWidth: true,
        caption: "Reason for Rejection",
        displayExpr: "DisplayName",
        valueExpr: "id",
        name: "rejectReason",
        disabled: true
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: '#8593A3'
    }, "Qty:")), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        sx: {
            border: '1px solid #E0E0E0',
            borderRadius: '5px',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        p: '3px',
        display: 'flex',
        justifyContent: 'center',
        sx: {
            borderRight: '1px solid #E0E0E0',
            borderRadius: 0,
            backgroundColor: '#F4F7FA'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleDecrement,
        size: "small"
    }, /*#__PURE__*/ React.createElement(GridRemoveIcon, null))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 8
    }, /*#__PURE__*/ React.createElement(TextField, {
        value: duplicateItemDetails && typeof duplicateItemDetails.Quantity === 'number' ? duplicateItemDetails.Quantity : 0,
        variant: "outlined",
        size: "small",
        inputProps: {
            style: {
                textAlign: 'center'
            }
        },
        sx: {
            border: 'none',
            '& fieldset': {
                border: 'none'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: 0
            }
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        display: 'flex',
        justifyContent: 'center',
        p: '3px',
        sx: {
            borderLeft: '1px solid #E0E0E0',
            borderRadius: 0,
            backgroundColor: '#F4F7FA'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleIncrement,
        size: "small"
    }, /*#__PURE__*/ React.createElement(GridAddIcon, null))))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        padding: 1,
        border: 1,
        borderRadius: 2,
        borderColor: "grey.300"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "removeButton",
        name: t('Remove'),
        variant: "outlined",
        style: {
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "10px",
            padding: "20px",
            width: '95%',
            alignSelf: 'center'
            //opacity: !selectedAdvisor ? 0.5 : 1,
        },
        onClick: function () {
            setManualJobsList(manualJobsList.filter(function (item) { return item.id !== (duplicateItemDetails === null || duplicateItemDetails === void 0 ? void 0 : duplicateItemDetails.ChildId); }));
            setShowDuplicateAlertPopup(false);
        },
        disabled: false
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "saveButton",
        name: t('Add'),
        variant: "contained",
        style: {
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "10px",
            padding: "20px",
            width: '95%',
            alignSelf: 'center'
            //opacity: !selectedAdvisor ? 0.5 : 1,
        },
        onClick: updateQuantity,
        disabled: false
    }))))))), /*#__PURE__*/ React.createElement(AlternatePartPopup, {
        alternetPartPopupOpen: alternetPartPopupOpen,
        setAlternetPartPopupOpen: setAlternetPartPopupOpen,
        replacePart: replacePart,
        searchedPart: searchedPart,
        setSearchedPart: setSearchedPart,
        alterNatePartDetails: alterNatePartDetails,
        setAlterNatePartDetails: setAlterNatePartDetails
    })));
};
